var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStoreClosed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2096_4490)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.5377 48.0967C73.826 48.0967 72.4385 46.7091 72.4385 44.9975C72.4385 31.0435 60.0579 19.691 44.8402 19.691C29.6225 19.691 17.2419 31.0435 17.2419 44.9975C17.2419 46.7091 15.8543 48.0967 14.1427 48.0967C12.431 48.0967 11.0435 46.7091 11.0435 44.9975C11.0435 27.6255 26.2047 13.4926 44.8402 13.4926C63.4757 13.4926 78.6369 27.6255 78.6369 44.9975C78.6369 46.7091 77.2494 48.0967 75.5377 48.0967Z",
    fill: "url(#paint0_linear_2096_4490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7612 69.0886C83.281 64.0493 83.281 58.1441 85.7612 53.1048L89.7867 44.9264C90.369 43.9848 89.6916 42.7695 88.5843 42.7695H1.09601C-0.0112116 42.7695 -0.688613 43.9848 -0.106313 44.9264L3.91913 53.1048C6.39939 58.1441 6.39939 64.0493 3.91913 69.0886L-0.106313 77.267C-0.688613 78.2087 -0.0112116 79.4239 1.09601 79.4239H88.5843C89.6916 79.4239 90.369 78.2087 89.7867 77.267L85.7612 69.0886Z",
    fill: "url(#paint1_linear_2096_4490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.439 77.4592H15.3666L7.28882 69.3661C6.1549 68.4484 5.43896 66.9731 5.43896 64.7861V58.2659C5.43896 54.0338 8.11618 52.4592 11.3339 52.4592C13.5788 52.4592 15.4711 53.1835 16.5449 54.522L39.439 77.4592Z",
    fill: "url(#paint2_linear_2096_4490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.439 77.4592H27.1145L20.1485 70.2607C19.7362 70.0726 19.439 69.7406 19.439 69.2648V53.6166C19.439 52.8035 20.3684 52.4592 21.2961 52.4592C22.1206 52.4592 22.9435 52.7308 23.1187 53.3592L30.7014 61.1948L46.439 77.4592Z",
    fill: "url(#paint3_linear_2096_4490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.439 77.4592H40.3839L32.2802 69.3572C31.1385 68.4394 30.439 66.966 30.439 64.7861V58.2659C30.439 54.0338 33.0738 52.4592 36.4687 52.4592C38.5034 52.4592 40.2719 53.0256 41.3639 54.3871L44.5706 57.5931L64.439 77.4592Z",
    fill: "url(#paint4_linear_2096_4490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7828 79H54.1562L46.065 70.5223C45.3977 69.9809 45 69.3421 45 68.6962C45 67.8316 45.7286 66.5598 46.6519 66.5598C47.7923 66.5598 48.5209 68.4428 50.779 68.4428C51.4376 68.4428 52.1348 68.2814 52.599 67.9015C52.5885 67.8868 52.5761 67.8721 52.564 67.8575L47.1792 62.2155C46.2053 61.3492 45.4905 60.1856 45.4415 58.4602C45.4397 58.396 45.438 58.3317 45.438 58.2657C45.438 54.4499 48.6192 53 51.6531 53C52.7776 53 55.6223 53.1945 56.3266 54.5656L58.7913 57.1481L75.8688 75.0413L76.8163 77.0584C77.3174 77.9061 76.734 79 75.7828 79Z",
    fill: "url(#paint5_linear_2096_4490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8637 79H66.3072L59.6754 70.2257C59.283 70.0225 59 69.664 59 69.1501V53.2749C59 52.4256 59.7719 52 60.5422 52H68.6115C69.0597 52 69.3523 52.3355 69.5159 52.7842L72.0475 55.7519C70.6313 60.1347 70.8161 65.035 72.6002 69.2817L74.9438 74.8645L75.8284 76.9716C76.2964 77.8573 75.7517 79 74.8637 79Z",
    fill: "url(#paint6_linear_2096_4490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 79H79.9629L73.5955 70.9261C73.2208 70.6968 73 70.3409 73 69.9562V54.2334C73 53.5771 73.6382 53 74.6085 53H78.7909C80.6982 53 82.3636 53.5746 83.4169 54.9582L82.7143 62.75L90 79Z",
    fill: "url(#paint7_linear_2096_4490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0403 55.4865C9.64078 55.4865 8.83042 56.2723 8.83042 57.9419V64.4484C8.83042 66.118 9.64062 66.9038 11.0647 66.9038C13.029 66.9038 13.1518 65.4061 13.2253 64.4484C13.299 63.54 14.1339 63.2944 15.1159 63.2944C16.4417 63.2944 17.0556 63.6382 17.0556 65.1115C17.0556 68.3769 14.4039 70.2431 10.8927 70.2431C7.67634 70.2431 5 68.6717 5 64.4484V57.9419C5 53.7189 7.67634 52.1475 10.8927 52.1475C14.4037 52.1475 17.0556 53.9152 17.0556 57.0336C17.0556 58.5069 16.4417 58.8506 15.1405 58.8506C14.1092 58.8506 13.2744 58.5804 13.2253 57.6967C13.2009 57.058 13.1273 55.4865 11.0403 55.4865Z",
    fill: "url(#paint8_linear_2096_4490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6653 70.0957C19.8304 70.0957 18.9956 69.7029 18.9956 68.9171V53.3014C18.9956 52.4912 19.9532 52.1475 20.9107 52.1475C21.8683 52.1475 22.8259 52.4912 22.8259 53.3014V66.7564H28.4239C29.1605 66.7564 29.5289 67.5912 29.5289 68.426C29.5289 69.2608 29.1606 70.0957 28.4239 70.0957H20.6653Z",
    fill: "url(#paint9_linear_2096_4490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6099 64.4484V57.9419C30.6099 53.7189 33.2371 52.1475 36.6253 52.1475C40.0136 52.1475 42.6653 53.7189 42.6653 57.9419V64.4484C42.6653 68.6716 40.0136 70.2431 36.6253 70.2431C33.2371 70.2431 30.6099 68.6716 30.6099 64.4484ZM38.835 57.9419C38.835 56.2476 38.0004 55.4865 36.6253 55.4865C35.2503 55.4865 34.4401 56.2476 34.4401 57.9419V64.4484C34.4401 66.1426 35.2503 66.9038 36.6253 66.9038C38.0004 66.9038 38.835 66.1426 38.835 64.4484V57.9419Z",
    fill: "url(#paint10_linear_2096_4490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4856 65.2832C52.4856 62.3124 44.7023 62.8278 44.7023 57.0825C44.7023 53.3995 47.9188 52 50.9878 52C52.289 52 55.8737 52.2454 55.8737 54.1608C55.8737 54.8236 55.4316 56.174 54.3514 56.174C53.4676 56.174 53.0008 55.2411 50.9878 55.2411C49.2444 55.2411 48.5324 55.9532 48.5324 56.7143C48.5324 59.1697 56.3157 58.7031 56.3157 64.8904C56.3157 68.426 53.7375 70.3411 50.1776 70.3411C46.9611 70.3411 44.2603 68.7698 44.2603 67.1493C44.2603 66.3145 44.9968 65.0869 45.9297 65.0869C47.0838 65.0869 47.8205 66.9038 50.1039 66.9038C51.2333 66.9038 52.4856 66.4618 52.4856 65.2832Z",
    fill: "url(#paint11_linear_2096_4490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.037 59.6362H65.7198C66.4563 59.6362 66.8737 60.3482 66.8737 61.1338C66.8737 61.7966 66.53 62.5824 65.7198 62.5824H62.037V66.7564H68.6169C69.3536 66.7564 69.771 67.5421 69.771 68.4506C69.771 69.2364 69.4272 70.0957 68.6169 70.0957H59.8762C59.0414 70.0957 58.2065 69.7029 58.2065 68.9171V53.3261C58.2065 52.5403 59.0414 52.1475 59.8762 52.1475H68.6169C69.4272 52.1475 69.771 53.007 69.771 53.7926C69.771 54.7009 69.3536 55.4865 68.6169 55.4865H62.037V59.6362Z",
    fill: "url(#paint12_linear_2096_4490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3453 52.0515C81.7638 52.0515 84.4391 53.6488 84.4391 57.9415V64.4055C84.4391 68.6982 81.7637 70.2955 78.3453 70.2955H73.9608C72.9453 70.2955 72.2764 69.7465 72.2764 69.1226V53.2246C72.2764 52.6006 72.9453 52.0516 73.9608 52.0516H78.3453V52.0515ZM76.1408 55.4457V66.9013H78.3455C79.7327 66.9013 80.5748 66.1026 80.5748 64.4055V57.9415C80.5748 56.2444 79.7325 55.4457 78.3455 55.4457H76.1408Z",
    fill: "url(#paint13_linear_2096_4490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8403 19.6909C51.1681 19.6909 57.0042 21.6551 61.6647 24.9518V17.6809C56.7075 15.0175 50.9614 13.4925 44.8403 13.4925V19.6909Z",
    fill: "url(#paint14_linear_2096_4490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8399 28.6408C49.7113 28.6408 53.6603 24.6917 53.6603 19.8204C53.6603 14.949 49.7113 11 44.8399 11C39.9685 11 36.0195 14.949 36.0195 19.8204C36.0195 24.6917 39.9685 28.6408 44.8399 28.6408Z",
    fill: "url(#paint15_linear_2096_4490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3961 17.71H46.9498V14.2637C46.9498 13.3957 46.246 12.692 45.3781 12.692H44.3008C43.4328 12.692 42.729 13.3957 42.729 14.2637V17.71H39.2827C38.4145 17.71 37.7109 18.4136 37.7109 19.2818V20.3591C37.7109 21.2272 38.4147 21.9308 39.2827 21.9308H42.729V25.3772C42.729 26.2453 43.4328 26.9489 44.3008 26.9489H45.3781C46.246 26.9489 46.9498 26.2453 46.9498 25.3772V21.9308H50.3961C51.2643 21.9308 51.9679 21.2272 51.9679 20.3591V19.2818C51.9679 18.4136 51.2643 17.71 50.3961 17.71Z",
    fill: "url(#paint16_linear_2096_4490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3735 12.2531C50.1687 13.5777 50.6263 15.1284 50.6263 16.7861C50.6263 21.6575 46.6774 25.6064 41.806 25.6064C40.1483 25.6064 38.5978 25.1488 37.2729 24.3536C38.8148 26.9221 41.6267 28.641 44.8405 28.641C49.712 28.641 53.6609 24.6919 53.6609 19.8206C53.6609 16.6067 51.942 13.7949 49.3735 12.2531Z",
    fill: "url(#paint17_linear_2096_4490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8395 27.9499C49.3293 27.9499 52.969 24.3102 52.969 19.8204C52.969 15.3306 49.3293 11.6909 44.8395 11.6909C40.3497 11.6909 36.71 15.3306 36.71 19.8204C36.71 24.3102 40.3497 27.9499 44.8395 27.9499Z",
    fill: "url(#paint18_linear_2096_4490)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2096_4490",
    x1: 44.8402,
    y1: 20.187,
    x2: 44.8402,
    y2: 44.5315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E566E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2096_4490",
    x1: 41.1588,
    y1: 53.734,
    x2: 52.0844,
    y2: 75.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2096_4490",
    x1: 21.311,
    y1: 69.396,
    x2: -2.1042,
    y2: 53.9925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2096_4490",
    x1: 32.3651,
    y1: 69.0564,
    x2: 14.088,
    y2: 60.0443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2096_4490",
    x1: 46.9243,
    y1: 68.4316,
    x2: 28.7262,
    y2: 60.0853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2096_4490",
    x1: 63.6668,
    y1: 69.3083,
    x2: 41.5876,
    y2: 62.5652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2096_4490",
    x1: 73.9163,
    y1: 69.6327,
    x2: 61.5059,
    y2: 63.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2096_4490",
    x1: 101.128,
    y1: 69.9796,
    x2: 85.7425,
    y2: 55.6814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2096_4490",
    x1: 10.779,
    y1: 58.9484,
    x2: 12.5504,
    y2: 72.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2096_4490",
    x1: 22.804,
    y1: 57.3868,
    x2: 24.5754,
    y2: 71.0262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2096_4490",
    x1: 35.9215,
    y1: 55.6833,
    x2: 37.6928,
    y2: 69.3227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2096_4490",
    x1: 49.1975,
    y1: 53.9591,
    x2: 50.9689,
    y2: 67.5984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2096_4490",
    x1: 62.8056,
    y1: 52.1917,
    x2: 64.577,
    y2: 65.8312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2096_4490",
    x1: 77.3785,
    y1: 53.3427,
    x2: 78.8929,
    y2: 68.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2096_4490",
    x1: 59.5395,
    y1: 19.2222,
    x2: 51.3623,
    y2: 19.2222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E566E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8228,
    stopColor: "#59465A",
    stopOpacity: 0.866
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564357"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2096_4490",
    x1: 41.4818,
    y1: 16.4622,
    x2: 48.593,
    y2: 23.5734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2096_4490",
    x1: 49.143,
    y1: 23.5114,
    x2: 40.8488,
    y2: 16.3979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2096_4490",
    x1: 46.3512,
    y1: 20.8556,
    x2: 61.9165,
    y2: 16.2898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#C7B6DF",
    stopOpacity: 0.289
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#A495C7",
    stopOpacity: 0.592
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    stopColor: "#8E80B7",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2096_4490",
    x1: 46.5106,
    y1: 22.5838,
    x2: 35.9261,
    y2: 5.08137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2096_4490"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreClosed);
export default __webpack_public_path__ + "static/media/store-closed.ba03154286ad3fca40c9b8e0e37f92de.svg";
export { ForwardRef as ReactComponent };